<template>
  <div class="contentA">
    <div class="content-left">
      <div class="content-left-top">
        <span @click="aaa">全部</span>
        <!-- <el-button size="mini" type="primary" plain style="background-color: #fff;" @click="addRow()">添加</el-button> -->
        <div class="btnZ" @click="addRow()">添加</div>
      </div>
      <div class="content-left-bottom">
        <div :class="index==indexA?'left-item active':'left-item'" v-for="(item,index) in tableDataEnd" :key="index"
             @click="active(item,index)">
          <div v-if="item.linkType!=='3'"
               style="width: 90%;display: flex;flex-direction: column;justify-content: space-between;">
            <p class="overflow-1" style="font-family: SourceHanSansCN-Regular;
            font-size: 14px;
            font-weight: normal;
            letter-spacing: 0em;
            color: #8E8E8E;
            text-align: start;">{{ item.name }}</p>
            <p class="overflow-1" style="font-family: SourceHanSansCN-Normal;
            font-size: 12px;
            font-weight: 350;
            letter-spacing: 0em;
            color: #8E8E8E;
            text-align: start;">序列号: {{ item.serial }}</p>
            <p class="overflow-1" style="font-family: SourceHanSansCN-Normal;
            font-size: 12px;
            font-weight: 350;
            letter-spacing: 0em;
            color: #8E8E8E;
            text-align: start;">验证码: {{ item.vcode }} </p>
          </div>
          <div v-if="item.linkType=='3'"
               style="width: 90%;display: flex;flex-direction: column;justify-content: space-between;">
            <p class="overflow-1" style="font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #8E8E8E;
text-align: start;">{{ item.name }}</p>
            <p class="overflow-1" style="font-family: SourceHanSansCN-Normal;
font-size: 12px;
font-weight: 350;
letter-spacing: 0em;
color: #8E8E8E;
text-align: start;"> 账号：{{ item.username }}</p>
            <p class="overflow-1" style="font-family: SourceHanSansCN-Normal;
font-size: 12px;
font-weight: 350;
letter-spacing: 0em;
color: #8E8E8E;
text-align: start;"> IP：{{ item.ip }} </p>
          </div>
          <div style="width: 10%;display: flex;justify-content: center;align-items: center;" @click.stop="a">
            <el-popover placement="bottom" width="60" trigger="click" popper-class="monitor-popper-class">
              <div class="popover-content">
                <p @click="handleEdit(index,item)">编辑</p>
                <p @click="monitorSyn(item)">同步</p>
                <p @click="toDecrypt(item)">解密</p>
                <p style="color: #ec0f0f;opacity: 0.6;" @click="handleDelete(index,item)">删除</p>
              </div>
              <!-- <span slot="reference" class="el-icon-caret-top"></span> -->

              <!-- <img slot="reference" src="../../../assets/image/tubiao/路径 2.png" alt=""> -->
              <div slot="reference" class="img"></div>
            </el-popover>
          </div>
        </div>
      </div>
    </div>
    <div class="content-right-l" @click="nextUp"><img src="../../../assets/image/tubiao/路径 3.png" alt=""></div>
    <div class="content-right-r" @click="next"><img src="../../../assets/image/tubiao/路径 3.png" alt=""></div>
    <div class="content-right">
      <!-- <div class="content-right-l"><img src="../../../assets/image/tubiao/路径 3.png" alt=""></div> -->
      <!-- <div class="content-right-r"></div> -->
      <div class="content-right-item" v-for="item in monitorList" :key="item.id" v-if="monitoring==1">
        <div class="video">
          <iframe ref="iframe" width="100%" height="100%" :src='item.showUrl' style="border: 0;height: 100%;"></iframe>
        </div>
        <div class="video2" v-if="item.status!=1">
          <div class="liXian">
            {{ item.msg }}
          </div>
        </div>
        <div class="video-info">
          <div v-if="item.status==1" style="display:flex;width:10.5vw;align-items: center;position: relative;">
            <img style="height:100%;padding: 0 13px;cursor:pointer;" v-if="item.type=='1'"
                 @click="toDetail(item.serial,item.channelNo,item.type,item.id)"
                 src="../../../assets/image/tubiao/qiang.png"/>
            <img class="qiu" @click="toDetail(item.serial,item.channelNo,item.type,item.id)"
                 style="height:100%;padding: 0 13px;" v-else-if="item.type=='2'"
                 src="../../../assets/image/tubiao/qiu.png"/>
            <div v-if="item.type!='1'" class="caozuo">点击操作</div>
            <!-- <span v-if="item.linkType!='3'" style="cursor: pointer;width:4.5vw" @click="toDetail(item.serial,item.channelNo,item.type,item.id)">操作</span> -->
            <span style="display:flex;width:11vw;font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #9E9E9E;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{ item.name }}</span>
          </div>
          <div v-if="item.status!=1" style="display:flex;width:10.5vw;align-items: center;">
            <img style="height:100%;padding: 0 13px;" v-if="item.type=='1'"
                 src="../../../assets/image/tubiao/lxQiang.png"/>
            <!-- <span v-if="item.linkType!='3'" style="cursor: pointer;width:4.5vw" @click="toDetail(item.serial,item.channelNo,item.type,item.id)">操作</span> -->
            <span style="display:flex;width:11vw;font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #9E9E9E;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{ item.name }}</span>
          </div>
          <div v-if="item.status!=1" class="handle">
            <!-- <el-button size="mini" plain type="primary">解密</el-button>
            <el-button size="mini" plain type="primary">编辑</el-button>
            <el-button size="mini" plain type="danger">删除</el-button> -->
            <span v-if="item.useType == '4'" style="border: 1px solid #D9D9D9;color: #D9D9D9;margin-right: 4px;"
                  @click="skipMonitorWarning(item)">预警数据</span>
            <span style="border: 1px solid #D9D9D9;color: #D9D9D9;margin-right: 4px;"
                  @click="toDetail(item.serial,item.channelNo,item.type,item.id)">回看</span>
            <span style="border: 1px solid #D9D9D9;color: #D9D9D9;margin-right: 4px;"
                  @click="toDecrypt1(item)">解密</span>
            <span style="border: 1px solid #D9D9D9;color: #D9D9D9;margin-right: 4px;" @click="handleEdit1(index,item)">编辑</span>
            <span style="border: solid 1px #D9D9D9;color: #D9D9D9;" @click="handleDelete1(index,item)">删除</span>
          </div>
          <div v-if="item.status==1" class="handle">
            <!-- <el-button size="mini" plain type="primary">解密</el-button>
            <el-button size="mini" plain type="primary">编辑</el-button>
            <el-button size="mini" plain type="danger">删除</el-button> -->
            <span v-if="item.useType == '4'" style="border: 1px solid #999;color: #8ea3ce;margin-right: 4px;"
                  @click="skipMonitorWarning(item)">预警数据</span>
            <span style="border: 1px solid #D9D9D9;color: #8ea3ce;margin-right: 4px;"
                  @click="toDetail(item.serial,item.channelNo,item.type,item.id)">回看</span>
            <span style="border: 1px solid #999;color: #8ea3ce;margin-right: 4px;" @click="toDecrypt1(item)">解密</span>
            <span style="border: 1px solid #999;color: #8ea3ce;margin-right: 4px;"
                  @click="handleEdit1(index,item)">编辑</span>
            <span style="border: solid 1px #F7A7A7;color: #F7A7A7;" @click="handleDelete1(index,item)">删除</span>
          </div>
        </div>
        <!-- <div class="detail" v-if="item.type==2">
          <span @click="toDetail(item.serial,item.channelNo,item.type,item.id)">设备详情</span>
        </div> -->
      </div>
      <!-- <div class="bbb"></div> -->
      <el-pagination
          @current-change="handleCurrentChange"
          :current-page="pageNumA"
          :page-size="9"
          layout="prev, pager, next, total"
          :total="total">
      </el-pagination>

      <!-- 新增窗口 -->
      <el-dialog
          :title="dialogTitle"
          :visible.sync="addFormVisible"
          center
          :append-to-body="true"
          :lock-scroll="false"
          class="add-form"
          width="30%"
      >
        <el-tabs v-model="curMachType">
          <el-tab-pane label="萤石云" name="1">
            <el-form
                :model="addForm"
                ref="addForm"
                label-width="100px"
                id="formData"
                :label-position="labelPosition"
                :rules="rules"
            >
              <el-form-item label="名称：" prop="name">
                <el-input v-model="addForm.name" placeholder="请输入名称" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="硬盘录像机：">
                <el-radio-group v-model="addForm.hardFlag">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0" style="margin-left:20px;">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="序列号：">
                <el-input v-model="addForm.serial" placeholder="请输入序列号" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="验证码：">
                <el-input v-model="addForm.vcode" placeholder="请输入验证码" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="备注：">
                <el-input type="textarea" v-model="addForm.remarks"></el-input>
              </el-form-item>
            </el-form>
            <div class="dialog-footer" style="margin-top:20px;text-align: center;">
              <el-button @click="addFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="网络直连" name="4">
            <el-form
                :model="addForm4"
                ref="addForm4"
                label-width="100px"
                id="formData"
                :label-position="labelPosition"
                :rules="rules"
            >
              <el-form-item label="名称：" prop="name">
                <el-input v-model="addForm4.name" placeholder="请输入名称" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="硬盘录像机：">
                <el-radio-group v-model="addForm4.hardFlag">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0" style="margin-left:20px;">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="IP：">
                <el-input v-model="addForm4.ip" placeholder="请输入IP地址" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="端口号：">
                <el-input v-model="addForm4.port" placeholder="请输入端口号" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="端口号2：">
                <el-input v-model="addForm4.port2" placeholder="请输入端口号" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="用户名：">
                <el-input v-model="addForm4.username" placeholder="请输入" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="密码：">
                <el-input v-model="addForm4.password" placeholder="请输入" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="备注：">
                <el-input type="textarea" v-model="addForm4.remarks"></el-input>
              </el-form-item>
            </el-form>
            <div class="dialog-footer" style="margin-top:20px;text-align: center;">
              <el-button @click="addFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="sumbitAddRow4('addForm4')">确 定</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="大华监控" name="2">
            <el-form
                :model="addForm1"
                ref="addForm1"
                label-width="100px"
                :label-position="labelPosition"
                :rules="rules1"
            >
              <el-form-item label="名称：" prop="name">
                <el-input v-model="addForm1.name" placeholder="请输入名称" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="硬盘录像机：">
                <el-radio-group v-model="addForm1.hardFlag">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="0" style="margin-left:20px;">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="序列号：">
                <el-input v-model="addForm1.serial" placeholder="请输入序列号" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="验证码：">
                <el-input v-model="addForm1.vcode" placeholder="请输入验证码" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="备注：">
                <el-input type="textarea" v-model="addForm1.remarks"></el-input>
              </el-form-item>
            </el-form>
            <div class="dialog-footer" style="margin-top:20px;text-align: center;">
              <el-button @click="addFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="sumbitAddRow1('addForm1')">确 定</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="IVS1800" name="3">
            <div>
              <div class="rowA">
                <span>设备名称:</span>
                <div class="inputA">
                  <el-input v-model="addForm3.name" placeholder="请输入" autocomplete="off"></el-input>
                </div>
              </div>
              <!-- <div class="rowA">
                <span>设备编号:</span>
                <div class="inputA">
                  <el-input v-model="addForm3.sn" placeholder="请输入" autocomplete="off"></el-input>
                </div>
              </div> -->
              <div class="rowA">
                <span>用户名:</span>
                <div class="inputA">
                  <el-input v-model="addForm3.username" placeholder="请输入" autocomplete="off"></el-input>
                </div>
              </div>
              <div class="rowA">
                <span>密码:</span>
                <div class="inputA">
                  <el-input v-model="addForm3.password" placeholder="请输入" autocomplete="off"></el-input>
                </div>
              </div>
              <div class="rowA">
                <span>服务请求IP:</span>
                <div class="inputA">
                  <el-input v-model="addForm3.ip" placeholder="请输入" autocomplete="off"></el-input>
                </div>
              </div>
              <!-- <div class="rowA">
                <span>端口:</span>
                <div class="inputA">
                  <el-input disabled v-model="addForm3.port" placeholder="请输入" autocomplete="off"></el-input>
                </div>
              </div> -->
              <div class="rowA">
                <span>回调地址:</span>
                <div class="inputA">
                  <el-input v-model="addForm3.callbackUrl" placeholder="请输入" autocomplete="off"></el-input>
                </div>
              </div>
            </div>
            <div class="dialog-footer" style="margin-top:20px;text-align: center;">
              <el-button @click="addFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="sumbitAddRow3">确 定</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
      <!-- 新增窗口 -->
      <el-dialog
          :title="dialogTitle"
          :visible.sync="addFormVisible1"
          center
          :append-to-body="true"
          :lock-scroll="false"
          class="add-form"
          width="30%"
      >
        <el-form
            :model="addForm2"
            ref="addForm2"
            label-width="140px"
            id="formData"
            :label-position="labelPosition"
        >
          <el-form-item label="名称：">
            <el-input v-model="addForm2.name" placeholder="请输入名称" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="序列号：">
            <el-input v-model="addForm2.serial" placeholder="请输入序列号" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="验证码：">
            <el-input v-model="addForm2.vcode" placeholder="请输入验证码" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="通道号：">
            <el-input v-model="addForm2.channelNo" placeholder="请输入通道号" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="排序：">
            <el-input v-model="addForm2.sort" placeholder="请输入排序" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="类型：">
            <el-radio-group v-model="addForm2.type">
              <el-radio label="1">枪机</el-radio>
              <el-radio label="2" style="margin-left:20px;">球机</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="使用类型：">
            <el-radio-group v-model="addForm2.useType">
              <el-radio :label="item.value" style="padding:1vh 0;" v-for="(item,index) in useTypes" :key="index">
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="摄像头硬件ID：" v-if="addForm2.useType=='4'">
            <el-input v-model="addForm2.camId" placeholder="请输入摄像头硬件ID" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input type="textarea" v-model="addForm2.remarks"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" style="margin-top:20px;text-align: center;">
          <el-button @click="addFormVisible1 = false">取 消</el-button>
          <el-button type="primary" @click="sumbitAddRow2('addForm2')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'

export default {
  data() {
    return {
      groupId: util.session.get('groupId'),
      monitorList: [],
      ysToken: '',
      ialogTitle: '编辑窗口', //弹出框标题
      labelPosition: 'right', // 添加设备弹出框position属性
      machType: '1', // 添加窗口-tag默认显示页
      addForm: {}, // 添加设备表单数组
      addForm1: {}, // 编辑设备表单数组
      addForm2: {
        id: '',
        monitorId: '',
        projectId: '',
        name: '',
        serial: '',
        vcode: '',
        sort: '',
        channelNo: '',
        type: '1',
        useType: '1',
        camId: '',
      }, // 添加设备表单数组
      addForm3: {
        name: '', // 设备名称
        sn: '', // 设备编号
        username: '', // 用户名
        password: '', // 用户密码
        ip: '', // 请求ip
        port: '', // 端口
        callbackUrl: '', // 回调地址
        id: ''
      },
      addForm4: {
        name: '',
        ip: '',
        port: '',
        port2: '',
        username: '',
        password: '',
        remarks: '',
      },
      radio: 1, // 弹窗口-录像机是否传值
      addFormVisible: false, // 弹出框是否显示
      addFormVisible1: false, // 弹出框是否显示
      tableDataName: '', // 搜索数据名
      tableDataEnd: [], // 监控表单数据
      tableDataEnd1: [], // 监控设备列表
      currentPage: 1, // 表单列表默认页
      pageSize: 999, // 表单列表默认显示数
      totalItems: 0, // 表单列表全部长度
      flag: false, // 搜索数据flag值
      groupId: util.session.get('groupId'),
      curMachType: '1', //当前设备  1：海康   2：大华
      dataText: '数据加载中...',
      rules: {
        name: [{required: true, message: '请输入设备名称', trigger: 'blur'}]
      },
      rules1: {
        name: [{required: true, message: '请输入设备名称', trigger: 'blur'}]
      },
      dialogTitle: '',
      indexA: 0,
      pageNumA: 1,
      total: 0,
      useTypes: [],
      hei: 2,
      nextPage: 0,
      dataItemS: [],
      date: null,
      date1: null,
      dateSS: null,
      monitoring: 1
    }
  },
  mounted() {
    this.getYsToken()
    this.getUseType()
    let that = this
    // 监听fullscreenchange事件,是为了兼容F11和ESC按键操作
    //添加退出全屏时的监听事件
    window.addEventListener("fullscreenchange", function (e) {
      let isFullScreen = document.fullscreenElement
      if (isFullScreen) {
        isFullScreen.src = that.chahgeUrl(isFullScreen.src, 'definition', 2)
      } else {
        isFullScreen = e.target
        isFullScreen.src = that.chahgeUrl(isFullScreen.src, 'definition', 1)
      }
    });
    window.addEventListener("mozfullscreenchange", function (e) {
      let isFullScreen = document.fullscreenElement
      if (isFullScreen) {
        isFullScreen.src = that.chahgeUrl(isFullScreen.src, 'definition', 2)
      } else {
        isFullScreen = e.target
        isFullScreen.src = that.chahgeUrl(isFullScreen.src, 'definition', 1)
      }
    });
    window.addEventListener("webkitfullscreenchange", function (e) {
      let isFullScreen = document.fullscreenElement
      if (isFullScreen) {
        isFullScreen.src = that.chahgeUrl(isFullScreen.src, 'definition', 2)
      } else {
        isFullScreen = e.target
        isFullScreen.src = that.chahgeUrl(isFullScreen.src, 'definition', 1)
      }
    });
    window.addEventListener("msfullscreenchange", function (e) {
      let isFullScreen = document.fullscreenElement
      if (isFullScreen) {
        isFullScreen.src = that.chahgeUrl(isFullScreen.src, 'definition', 2)
      } else {
        isFullScreen = e.target
        isFullScreen.src = that.chahgeUrl(isFullScreen.src, 'definition', 1)
      }
    })
    // if(util.session.get('monitoring')){
    //   this.indexA=util.session.get('monitoring').indexA
    //   this.pageNumA=util.session.get('monitoring').pageNumA
    // }
    // setTimeout(() => {
    //   this.monitoring={indexA:this.indexA,pageNumA:this.pageNumA}
    //   util.session.set('monitoring',this.monitoring)
    // console.log('刷新了')
    //   this.$router.go(0)
    // },6000);
  },
  beforeDestroy() {
    if (this.date != null && this.date != '') {
      clearInterval(this.date)
    }
    clearInterval(this.date1)
    this.dataItemS.forEach((itemA) => {
      util.session.remove(`${itemA}`)
    })
    if (this.dateSS != null) {
      clearInterval(this.dateSS)
    }
  },
  methods: {
    aaa() {
      console.log(window)
    },
    chahgeUrl(url, arg, argVal) {
      let pattern = arg + '=([^&]*)';
      let replaceText = arg + '=' + argVal;
      if (url.match(pattern)) {
        let tmp = '/(' + arg + '=)([^&]*)/gi';
        tmp = url.replace(eval(tmp), replaceText);
        return tmp;
      } else {
        if (url.match('[\?]')) {
          return url + '&' + replaceText;
        } else {
          return url + '?' + replaceText;
        }
      }
    },
    next() {
      if (this.pageNumA < this.nextPage) {
        this.pageNumA = ++this.pageNumA
        this.getSonList(this.tableDataEnd[this.indexA])
      }
    },
    nextUp() {
      if (this.pageNumA > 1) {
        this.pageNumA = --this.pageNumA
        this.getSonList(this.tableDataEnd[this.indexA])
      }
    },
    //获取使用类型字典 mt_useType
    getUseType() {
      var that = this
      myHttp.getDictByType({
        type: 'mt_useType'
      }).then(function (resp) {
        if (resp.data.code == '200') {
          that.useTypes = resp.data.data.dictList
          // that.getData()
        }
      })
    },
    //编辑
    sumbitAddRow2(formName) {
      var that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          delete that.addForm.createDate
          if (that.addForm.id == '') {
            myHttp.createCameraInfo(that.addForm2).then(function (resp) {
              if (resp.data.code == "200") {
                that.$message.success("添加成功");
                that.addFormVisible = false;
                that.getData();
              } else {
                that.$message.error(resp.data.msg);
              }
            })
          } else if (that.type == "1") {
            //萤石云修改
            myHttp.updateCameraInfo({
              id: that.addForm2.id,
              monitorId: that.addForm2.monitorId,
              projectId: that.addForm2.projectId,
              name: that.addForm2.name,
              serial: that.addForm2.serial,
              vcode: that.addForm2.vcode,
              sort: that.addForm2.sort,
              channelNo: that.addForm2.channelNo,
              type: that.addForm2.type,
              useType: that.addForm2.useType,
              camId: that.addForm2.camId,
            }).then(
                function (resp) {
                  if (resp.data.code == "200") {
                    that.$message.success("修改成功");
                    that.addFormVisible1 = false;
                    that.getData();
                  } else {
                    that.$message.error(resp.data.msg);
                  }
                },
                function () {
                }
            );
          } else {
            //大华修改
            myHttp.updateCameraInfo({
              id: that.addForm2.id,
              monitorId: that.addForm2.monitorId,
              projectId: that.addForm2.projectId,
              name: that.addForm2.name,
              serial: that.addForm2.serial,
              vcode: that.addForm2.vcode,
              sort: that.addForm2.sort,
              channelNo: that.addForm2.channelNo,
              type: that.addForm2.type,
              useType: that.addForm2.useType,
              camId: that.addForm2.camId,
            }).then(
                function (resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('修改成功')
                    that.addFormVisible1 = false
                    that.getData()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function () {
                }
            )
          }
        }
      });
    },
    sumbitAddRow3() {
      let that = this
      console.log(that.addForm3.id)
      if (that.addForm3.id == '') {
        this.addForm3.projectId = util.session.get('groupId')
        myHttp.monitorCreateInfo(this.addForm3).then(function (resp) {
          if (resp.data.code == "200") {
            that.$message.success("添加成功");
            that.addFormVisible = false;
            that.getData();
          } else {
            that.$message.error(resp.data.msg);
          }
        })
      } else {
        myHttp.monitorUpdateInfo({
          projectId: util.session.get('groupId'),
          id: that.addForm3.id,
          name: that.addForm3.name, // 设备名称
          sn: that.addForm3.sn, // 设备编号
          username: that.addForm3.username, // 用户名
          password: that.addForm3.password, // 用户密码
          ip: that.addForm3.ip, // 请求ip
          port: that.addForm3.port, // 端口
          callbackUrl: that.addForm3.callbackUrl,
          machType: '3',
          linkType: '1',
          hardFlag: '1'
        }).then(
            function (resp) {
              if (resp.data.code == "200") {
                that.$message.success("修改成功");
                that.addFormVisible = false;
                that.getData();
              } else {
                that.$message.error(resp.data.msg);
              }
            },
            function () {
            }
        );
      }
    },
    // 编辑数据
    handleEdit1(index, row) {
      this.dialogTitle = '编辑设备信息'
      this.addFormVisible1 = true
      this.addForm2 = {...row}
      // this.addForm = row

    },
    toDecrypt1(row) {
      var that = this
      myHttp.encryptOffMonitor({
        projectId: this.groupId,
        serial: row.serial,
        vcode: row.vcode
      }).then(function (resp) {
        console.log(resp)
        if (resp.data.code == '200') {
          that.$message.success('解密成功')
        } else {
          that.$message.error(resp.data.msg)
        }
      })
    },
    // 删除数据
    handleDelete1(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.deleteCamera({
          id: row.id
        })
            .then(function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('删除成功')
                that.getYsToken()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
      })
    },
    // 删除数据
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.monitorDeleteInfo({
          id: row.id
        }).then(function (resp) {
          if (resp.data.code == '200') {
            that.$message.success('删除成功')
            that.getYsToken()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
      })
    },
    //解密
    toDecrypt(row) {
      var that = this
      myHttp.encryptOffMonitor({
        projectId: this.groupId,
        serial: row.serial,
        vcode: row.vcode
      }).then(function (resp) {
        console.log(resp)
        if (resp.data.code == '200') {
          that.$message.success('解密成功')
        } else {
          that.$message.error(resp.data.msg)
        }
      })
    },
    // 将新增的数据添加到表格中
    sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (that.addForm.id == '') {
            //添加
            myHttp.monitorCreateInfo(that.addForm).then(
                function (resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('添加成功')
                    that.addFormVisible = false
                    that.getYsToken()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function () {
                }
            )
          } else {
            //修改
            delete that.addForm.cameraList
            delete that.addForm.createDate
            if (that.addForm.password == '') {
              delete that.addForm.password
            }
            myHttp.monitorUpdateInfo(that.addForm).then(
                function (resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('修改成功')
                    that.addFormVisible = false
                    that.getYsToken()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function () {
                }
            )
          }
        }
      })
    },
    sumbitAddRow1(formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (that.addForm1.id == '') {
            myHttp.monitorCreateInfo(that.addForm1).then(
                function (resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('添加成功')
                    that.addFormVisible = false
                    that.getYsToken()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function () {
                }
            )
          } else {
            delete that.addForm1.cameraList
            delete that.addForm1.createDate
            myHttp.monitorUpdateInfo(that.addForm1).then(
                function (resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('修改成功')
                    that.addFormVisible = false
                    that.getYsToken()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function () {
                }
            )
          }
        }
      })
    },
    // 网络直连
    sumbitAddRow4(formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (that.addForm4.id == '') {
            //添加
            myHttp.monitorCreateInfo(that.addForm4).then(
                function (resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('添加成功')
                    that.addFormVisible = false
                    that.getYsToken()
                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function () {
                }
            )
          } else {
            //修改
            delete that.addForm4.cameraList
            delete that.addForm4.createDate
            if (that.addForm4.password == '') {
              delete that.addForm4.password
            }
            myHttp.monitorUpdateInfo(that.addForm4).then(
                function (resp) {
                  if (resp.data.code == '200') {
                    that.$message.success('修改成功')
                    that.addFormVisible = false
                    that.getYsToken()

                  } else {
                    that.$message.error(resp.data.msg)
                  }
                },
                function () {
                }
            )
          }
        }
      })
    },
    //同步
    monitorSyn(row) {
      if (row.machType == 3) {
        let that = this
        myHttp.syncDeviceList({
          id: row.id
        }).then(function (resp) {
          if (resp.data.code == '200') {
            that.$message.success('同步摄像头成功')
          } else {
            that.$message.error(resp.data.msg)
          }
        })
        return
      }
      var that = this
      myHttp.registerMonitor({
        id: row.id
      }).then(function (resp) {
        if (resp.data.code == '200') {
          that.$message.success('同步摄像头成功')
        } else {
          that.$message.error(resp.data.msg)
        }
      })
      console.log(row)
    },
    // 编辑数据
    handleEdit(index, row) {
      this.dialogTitle = '编辑设备信息'
      this.addFormVisible = true
      for (var i in this.addForm) {
        this.addForm[i] = row[i]
      }
      this.curMachType = row.machType
      if (row.machType == '1') {
        this.addForm = row
        console.log(this.addForm)
      } else if (row.machType == '2') {
        this.addForm1 = row
        console.log(this.addForm1)

      } else if (row.machType == '4') {
        this.addForm4 = row
        console.log(this.addForm4)

      } else {
        this.addForm3 = row
        console.log(this.addForm3)
      }
      // this.addForm = row
    },
    //跳转单个视频
    toDetail(id, channel, type, mid) {
      this.$router.push({path: '/monitCtl/' + id + '/' + channel + '/' + type + '/' + mid})
    },
    handleCurrentChange(val) {
      console.log('触发了')
      this.pageNumA = val
      this.getSonList(this.tableDataEnd[this.indexA])
    },
    // 侧边点击
    active(item, index) {
      if (index == this.indexA) {
        return
      }
      this.pageNum = 1
      this.indexA = index
      this.pageNumA = 1
      this.getSonList(item)
    },
    // 获取数据
    getData() {
      var option = {
        name: this.tableDataName,
        // pageNum: this.currentPage,
        // pageSize: this.pageSize,
        deviceName: '',
        projectId: util.session.get('groupId')
      }
      var that = this
      myHttp.getMonitListByProjectId(option).then(
          function (resp) {
            if (resp.data.code == '200') {
              console.log(resp, '0.0')
              // console.log(resp.data.data.monitorList)
              var list = resp.data.data.monitorList || []
              // for (var i = 0; i < list.length; i++) {
              //   list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              // }
              that.tableDataEnd = list
              that.getSonList(that.tableDataEnd[that.indexA])
              that.totalItems = list.length
              if (that.tableDataEnd.length == 0) {
                that.dataText = '暂无数据'
              }
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '暂无数据'
            }
          },
          function () {
          }
      )
    },
    // 获取摄像头列表
    getSonList(item) {
      if (this.date != null && this.date != '') {
        console.log('销毁了')
        clearInterval(this.date)
      }
      if (this.dateSS != null && this.dateSS != '') {
        console.log('销毁了')
        clearInterval(this.dateSS)
      }
      this.dataItemS.forEach((itemA) => {
        util.session.remove(`${itemA}`)
      })
      var option = {
        pageNum: this.pageNumA,
        pageSize: 9,
        monitorId: item.id,
        projectId: util.session.get('groupId')
      }
      var that = this
      myHttp.getListByMonitorIdNew(option).then(
          function (resp) {
            if (resp.data.code == '200') {
              console.log(resp.data.data.cameraList, '摄像头列表')
              var list = resp.data.data.cameraList || []
              // for (var i = 0; i < list.length; i++) {
              //   list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              // }
              that.tableDataEnd1 = list.list
              that.total = list.total
              that.nextPage = list.nextPage
              for (var i = 0; i < that.tableDataEnd1.length; i++) {
                if (that.tableDataEnd1[i].linkType == '3') {
                  if (that.tableDataEnd1[i].hardFlag == '1') {
                    that.tableDataEnd1[i].showUrl = '/ie/one.html?ip=' + that.tableDataEnd1[i].monitorIp + '&port=' + that.tableDataEnd1[i].port2 + '&channel=' + that.tableDataEnd1[i].channelNo + '&username=' + that.tableDataEnd1[i].username + '&psd=' + that.tableDataEnd1[i].password
                  } else {
                    that.tableDataEnd1[i].showUrl = '/ie/one.html?ip=' + that.tableDataEnd1[i].ip + '&port=' + that.tableDataEnd1[i].port2 + '&channel=' + that.tableDataEnd1[i].channelNo + '&username=' + that.tableDataEnd1[i].username + '&psd=' + that.tableDataEnd1[i].password
                  }
                } else {
                  that.tableDataEnd1[i].showUrl = '/monitor/view/one.html?serial=' + that.tableDataEnd1[i].serial + '&channel=' + that.tableDataEnd1[i].channelNo + '&token=' + that.ysToken
                }
                that.tableDataEnd1[i].isEditName = false
              }
              that.date = setInterval(() => {
                that.tableDataEnd1.forEach((item, index) => {
                  that.dataItemS.push(item.channelNo)
                  setTimeout(() => {
                    if (window.sessionStorage.getItem(`${that.tableDataEnd1[index].channelNo}`) != 'success') {
                      item.status = 2
                      item.msg = window.sessionStorage.getItem(`${that.tableDataEnd1[index].channelNo}`)
                    } else {
                      item.status = 1
                    }

                  }, 2000)
                })

              }, 180000);
              that.monitorList = that.tableDataEnd1
              for (let i = 0; i < that.monitorList.length; i++) {
                if (that.monitorList[i].camId == "") {
                  that.monitorList[i].camId = null
                }
              }
              console.log(that.monitorList)
              console.log(that.monitorList, '***********')
              if (that.tableDataEnd1.length == 0) {
                that.dataText = '暂无数据'
              }
            } else {
              console.log(resp.data.msg)
              that.$message.error(resp.data.msg)
              that.dataText = '暂无数据'
            }
            that.dateSS = setInterval(() => {
              that.monitoring = 2
              setTimeout(() => {
                that.monitoring = 1

              }, 1000)
            }, 300000);
          },
          function () {
          }
      )
    },
    /**
     * 新增设备
     */
    addRow() {
      // console.log(this.addForm.id);
      this.dialogTitle = '新增设备'
      this.addFormVisible = true
      //海康-萤石云
      this.addForm = {
        id: '',
        name: '',
        machType: '1',
        linkType: '1',
        hardFlag: '1', //是否有硬盘录像机
        serial: '',
        vcode: '',
        remarks: '',
        projectId: util.session.get('groupId')
      }
      //硬盘录像机-直连
      this.addForm4 = {
        id: '',
        name: '',
        machType: '4',
        linkType: '3',
        hardFlag: '1', //是否有硬盘录像机
        ip: '',
        port: '',
        port2: '',
        username: '',
        password: '',
        remarks: '',
        projectId: util.session.get('groupId')
      }
      //大华
      this.addForm1 = {
        id: '',
        name: '',
        machType: '2',
        linkType: '2',
        hardFlag: '1', //是否有硬盘录像机
        serial: '',
        vcode: '',
        remarks: '',
        projectId: util.session.get('groupId')
      }

      //1800
      this.addForm3 = {
        machType: '3',
        linkType: '4',
        hardFlag: '1', //是否有硬盘录像机
        id: ''
      }
    },
    //获取token
    getYsToken() {
      var that = this
      myHttp.getYsToken({
        projectId: this.groupId
      }).then(function (resp) {
        if (resp.data.code == '200') {
          that.ysToken = resp.data.data.accessToken || ''
          // that.getDevice()
          that.getData()
        }
      })
    },
    //获取监控摄像头
    getDevice() {
      var that = this
      myHttp.getCameraPageListByProjectId({
        projectId: this.groupId,
        pageNum: 1,
        pageSize: 9,
        useType: '',
        name: ''
      }).then(function (resp) {
        console.log(resp);
        if (resp.data.code == '200') {
          var list = resp.data.data.PageInfo.list || [];
          for (var i = 0; i < list.length; i++) {
            if (list[i].linkType == '3') {
              if (list[i].hardFlag == '1') {
                list[i].showUrl = '/ie/one.html?ip=' + list[i].monitorIp + '&port=' + list[i].port2 + '&channel=' + list[i].channelNo + '&username=' + list[i].username + '&psd=' + list[i].password
              } else {
                list[i].showUrl = '/ie/one.html?ip=' + list[i].ip + '&port=' + list[i].port2 + '&channel=' + list[i].channelNo + '&username=' + list[i].username + '&psd=' + list[i].password
              }
            } else {
              list[i].showUrl = '/monitor/view/one.html?serial=' + list[i].serial + '&channel=' + list[i].channelNo + '&token=' + that.ysToken
            }
            list[i].isEditName = false
          }
          that.monitorList = list
        }
      })
    },
    skipMonitorWarning(item) {
      console.log(item);
      this.$router.push({name: 'monitoringEarlyWarning', params: {camId: item.camId, name: item.name}})
    },
    a() {
    },
    amplification() {
      console.log(111);
    }
  },
}
</script>

<style scoped>
.contentA {
  display: flex;
  height: 100%;
  padding: 10px 0;
  padding-left: 10px;
}

.content-left {
  width: 14vw;
  height: 100%;
  background-color: #ffffff;
  box-shadow: 0px 3px 10px 0px rgba(77, 110, 177, 0.5);
  border-radius: 6px;
}

.content-right {
  position: relative;
  height: 100%;
  width: 73.5vw;
  margin-left: 0.7vw;
  background-color: #ffffff;
  box-shadow: 0px 3px 8px 0px rgba(77, 110, 177, 0.5);
  border-radius: 6px;
  padding: 1vh 1.2vw;
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  align-content: flex-start;
}

.content-right-l {
  position: absolute;
  left: 15vw;
  top: 1vh;
  width: 1.8vw;
  z-index: 200;
  height: 88.6vh;
  border-radius: 0px 6px 6px 0px;
  background: rgba(216, 216, 216, 0.2);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
}

.content-right-l > img {
  transform: rotate(90deg);
  width: 2vw;
}

.content-right-r {
  position: absolute;
  right: 0.9vw;
  top: 1vh;
  width: 1.8vw;
  z-index: 200;
  height: 88.6vh;
  border-radius: 0px 6px 6px 0px;
  background: rgba(216, 216, 216, 0.2);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
}

.content-right-r > img {
  transform: rotate(270deg);
  width: 2vw;
}

.content-right-l:hover {
  opacity: 1;
}

.content-right-r:hover {
  opacity: 1;
}

.content-left-top {
  height: 5vh;
  border-bottom: 1px solid #ccc;
  padding: 1vh 0.7vw;
  display: flex;
  justify-content: space-between;
}

.content-left-bottom {
  height: calc(100% - 5vh);
  padding: 0 2px;
  overflow: auto;
}

.left-item {
  display: flex;
  height: 8.5vh;
  border: 1px solid #F1F1F1;
  padding: 4px 12px;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 2px;
}

.left-item:hover {
  background-color: #F3F9FF;
}

.popover-content {
  text-align: center;
  font-family: PingFang-SC-Medium;
  color: #666;
}

.popover-content > p {
  height: 3vh;
  line-height: 3vh;
  cursor: pointer;
}

.popover-content > p:hover {
  background-color: #e4ecfc;
  border-radius: 6px;
}

.content-right-item:nth-child(3n) {
  margin-right: 0;
}

.content-right-item {
  margin-right: 1vw;
  margin-top: 0.6vw;
  position: relative;
  width: 23vw;
  height: 26.2vh;
  box-shadow: 2px 2px 7px 0px rgba(77, 110, 177, 0.5);
  position: relative;
}

.video {
  height: 85%;
}

.video2 {
  height: 85%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.video-info {
  height: 15%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1vw;
  padding-left: 2px;
}

.handle >>> .el-button--mini {
  padding: 5px 10px;
}

.detail {
  position: absolute;
  top: 1vh;
  right: 1vw;
  width: 64px;
  height: 30px;
  background-color: #ffffff;
  border-radius: 6px;
  border: solid 2px #8ea3ce;
  opacity: 0.4;
  text-align: center;
}

.detail > span {
  font-family: PingFang-SC-Medium;
  text-decoration: underline;
  color: #0d3a95;
  cursor: pointer;
  font-size: 12px;
}

.to-left {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 100%;
  background-color: rgba(136, 147, 168, .6);
  opacity: 0.7;
  left: 0;
  top: 0;
  border-radius: 6px 0px 0px 6px;
}

.to-right {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 100%;
  background-color: rgba(136, 147, 168, .6);
  opacity: 0.7;
  right: 0;
  top: 0;
  border-radius: 0px 6px 6px 0px;
}

/* .to-left > div{
  width: 40px;
  height: 50px;
  background: url('../../../../../assets/image/monitor/left.png');
  cursor: pointer;
}
.to-left > div:hover{
  background: url('../../../../../assets/image/monitor/left-have.png');
} */
/* .to-right > div{
  width: 40px;
  height: 50px;
  background: url('../../../../../assets/image/monitor/right.png');
  cursor: pointer;
} */
/* .to-right > div:hover{
  background: url('../../../../../assets/image/monitor/right-have.png');
} */
.handle > span {
  padding: 2px 5px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8vw;

}

.handle {
  width: 11.3vw;
  display: flex;
  justify-content: end;
}

.el-pagination {
  padding-top: 5px !important;
  padding-bottom: 0px !important;
  position: absolute;
  bottom: 1vh;
  left: 0;
}

.bbb {
  width: 100%;
  height: 1vh;
}

.active {
  background-color: #F5F7FA;
}

.liXian {
  width: 100%;
  height: 100%;
  background-color: #EEEEEE;
  font-family: SourceHanSansCN-Regular;
  font-size: 30px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #D9D9D9;
  display: flex;
  justify-content: center;
  align-items: center;
}

.caozuo {
  position: absolute;
  left: 0vh;
  top: -4.4vh;
  width: 66px;
  height: 32.35px;
  border-radius: 6px;
  background: rgba(241, 234, 234, 0.3);
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.4);
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #FFFFFF;
  border: 2px solid rgba(101, 127, 181, 0.9);
  line-height: 32.35px;
  display: none;
}

.qiu:hover {
  cursor: pointer;
}

.qiu:hover + .caozuo {
  display: block;
}

.btnZ {
  width: 50px;
  height: 24px;
  border-radius: 4px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid #999999;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #666666;
}

.btnZ:hover {
  background-color: #4D6EB1;
  color: #fff;
  cursor: pointer;
}

.rowA {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  align-items: center;
}

.rowA > span {
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #9E9E9E;
  margin-left: 3%;
  width: 7vw;
  text-align: end;
  padding-right: 1vw;
}

.inputA {
  width: 79%;
}

.img {
  background: url('../../../assets/image/tubiao/路径 2.png');
  background-repeat: no-repeat;
  width: 1vw;
  height: 1vw;
  background-size: 1vw;
}

.img:focus {
  background: url('../../../assets/image/tubiao/路径.png');
  background-repeat: no-repeat;
  width: 1vw;
  height: 1vw;
  background-size: 1vw;
}
</style>


<style>
.monitor-popper-class {
  min-width: 0;
  width: 88px !important;
  padding: 4px 4px;
}
</style>